import { Coordinate } from '~/types/geo'

export const useLocation = () => {
  const getCurrentCoordinate = (): Promise<Coordinate> => {
    return new Promise((resolve, reject) => {
      if (process.client) {
        window.navigator.geolocation?.getCurrentPosition(
          ({ coords }) => {
            const coordinate: Coordinate = {
              lat: coords.latitude,
              lng: coords.longitude,
            }
            resolve(coordinate)
          },
          (error) => {
            reject(error)
          }
        )
      }
    })
  }

  const checkPermissionState = async () => {
    if (!process.client || !window.navigator.permissions) return null
    const { state } = await window.navigator.permissions.query({
      name: 'geolocation',
    })
    // state will be "denied" | "granted" | "prompt"
    return state
  }

  return {
    getCurrentCoordinate,
    checkPermissionState,
  }
}
